import React from 'react';
import HeroSection from '../components/home/HeroSection';
import FeaturesSection from '../components/home/FeaturesSection';
import PrivacyBand from '../components/home/PrivacyBand';
import DisclaimersSection from '../components/home/DisclaimersSection';
import StoreStatusSection from '../components/home/StoreStatusSection';
import ContactSection from '../components/home/ContactSection';

const Home = () => {
  return (
    <main>
      <HeroSection />
      <FeaturesSection />
      <PrivacyBand />
      <DisclaimersSection />
      <StoreStatusSection />
      <ContactSection />
    </main>
  );
};

export default Home;